
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { projectActions } from "../../../store/reducers/projectReducer";
import * as _str from 'underscore.string';
import { userActions } from "../../../store/reducers/userReducer";
import { licenseActions } from '@src/store/reducers/licenseReducer';

@Component({
    selector: 'projectWizard',
    template: require('./projectWizard.html'),
    styles: [require('./_projectWizard.scss')]
})

export class ProjectWizardComponent implements OnInit, OnDestroy {

    public projectData: any;
    public steps: any;
    public isValid: boolean
    public resetMainScripts: boolean
    public form: any
    public stepid: any
    public title_publish;
    public msg_publish;
    public success_save;
    public $translate;


    constructor(private store: Store, @Inject('$scope') public $scope: any, @Inject('$state') public state: any, @Inject('$stateParams') public $stateParams: any,
        private dialogManagerService: DialogManagerService, @Inject('$filter') private $filter: any,
        @Inject('projectsLocalHistoryService') private projectsLocalHistoryService: any) {
        this.form = this
        this.stepid = this.stepId()
        this.$translate = $filter('translate');
    }

    ngOnInit() {
        this.steps = [
            { id: 1, text: 'Project Settings' },
            { id: 2, text: 'Environment Types' },
            { id: 3, text: 'Assign ' + this.$filter('dbTypeItem')(["Schemas"], this.state.params.dbType) }
        ];
        this.$scope.$watch(() => this.store.getState().project.data, (newVal, oldVal) => {

            if (newVal == null && oldVal == null)
                return;


            this.success_save = this.$translate('SUCCESS_PROJECT_SAVE')



            this.title_publish = this.$translate('PUBLISH_PROJECT_TITLE')


            this.msg_publish = this.$translate('PUBLISH_PROJECT_MSG')


            if (newVal != null && newVal.dbTypeId == 0)
                newVal.dbTypeId = parseInt(this.state.params.dbType)
            if ((!newVal?.dbTypeId || isNaN(newVal.dbTypeId)) && newVal?.databaseType)
                newVal.dbTypeId = newVal.databaseType.id
            this.projectData = newVal;
            if (this.projectData != null) {
                this.insertToJson('editScripts', true)
            }

            if (this.projectData != null &&
                this.projectData.parentId == null &&
                this.projectData.userInitiatedChange &&
                this.store.getState().project.mainScriptsSourcePath &&
                this.resetMainScripts) {
                //this.projectData.options['ScriptOutputFolder'] = this.store.getState().project.mainScriptsSourcePath;
                this.resetMainScripts = false;
            }
        });

        this.$scope.$watch(() => this.projectData
            , (newVal, oldVal) => {
                if ((newVal && oldVal) && (newVal.dbTypeId != oldVal.dbTypeId))
                    this.updateSteps(newVal.dbTypeId);
            }, true)

        this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
            this.store.dispatch({ type: userActions.REFRESH_USER_CAN_LINK_CMS });
            this.store.dispatch({
                type: userActions.USER_CAN_LINK_CMS_TO_PROJECT,
                payload: { userId: res.data.id, projectId: '0' },
                customErrorHandling: true,
                silentRequest: true,
            });
        });
        this.store.dispatch({ type: projectActions.GET_COMPARISON_TYPES });
        this.store.dispatch({ type: projectActions.GET_BASELINE_TYPES });
        this.resetMainScripts = false;

    }

    ngOnDestroy(): void {
        this.store.getState().project.data = null;
        this.store.getState().project.environmentTypes = null;
        this.store.dispatch({ type: projectActions.RESET_SCHEMAS_LIST });
    }


    updateSteps(dbTypeId) {
        this.steps = [
            { id: 1, text: 'Project Settings' },
            { id: 2, text: 'Environment Types' },
            { id: 3, text: 'Assign ' + this.$filter('dbTypeItem')(["Schemas"], dbTypeId.toString()) }
        ];
    }

    stepId() {
        return this.state.current.params.step;
    }

    convertLowercaseWithoutSpace(str) {
        if (str && str.trim().length > 0) {
            str = str.trim().toLowerCase();
            str = str.replace(/ /g, '_');
        }
        return str;
    }

    setProjectData(projectData) {
        let fieldName = projectData.fieldName;
        let value = projectData.value;
        let fieldName2 = projectData.fieldName2
        let fieldName3 = projectData.fieldName3
        this.insertToJson(fieldName, value, fieldName2, fieldName3)
    }

    connectSchemasTempIdToPass(projectData) {
        const tempIdToPassMap = new Map();
        projectData.environmentTypes.forEach((envType) => {
            envType.environments.forEach((env) => {
                env.schemas.forEach((schema) => {
                    tempIdToPassMap.set(schema.tempSchemaId, schema.connectionProperties.password);
                })
            })
        })
        return tempIdToPassMap;
    }

    connectSchemasIdToPass(projectData, tempIdToPassMap) {
        const IdToPassMap = new Map();
        projectData.environmentTypes.forEach((envType) => {
            envType.environments.forEach((env) => {
                env.schemas.forEach((schema) => {
                    const pass = tempIdToPassMap.get(schema.tempSchemaId);
                    IdToPassMap.set(schema.id, pass);
                })
            })
        })
        return IdToPassMap;
    }


    setSchemasPass(projectData, passMap) {
        projectData.environmentTypes.forEach((envType) => {
            envType.environments.forEach((env) => {
                env.schemas.forEach((schema) => {
                    schema.connectionProperties.password = passMap.get(schema.id);
                })
            })
        })
    }



    finish() {
        if (!this.validate()) {
            return;
        }
        this.store.dispatch({
            type: projectActions.COMMIT_PROJECT,
            payload: { project: this.projectData },
            callback: (response) => {
                if (response.data.validationErrors == null) {
                    this.dialogManagerService.showSuccessDialog({
                        title: this.title_publish,
                        text: this.msg_publish,
                    });
                    this.projectData = null;
                    this.dialogManagerService.showSuccessDialog({ title: this.success_save, text: '' });
                    const { id = null, name = null, isDraft = null } = { ...response.data.projectDraft };
                    this.projectsLocalHistoryService.AddProjectHistory({ id: parseInt(id), name: name, isDraft: isDraft }, this.state.$current.locals.globals.userDetails.data.id);
                    //check if draft is deleted, while its not keep checking until it is and then go to the specific project that was created
                    this.store.dispatch({
                        type: projectActions.GET_IS_PROJECT_EXISTS,
                        payload: { projectId: id }
                    }).then(() => {
                        this.$scope.$watch(() => this.store.getState().project, (newVal, oldVal) => {
                            if (oldVal) { }
                            if (newVal.isProjectExists) {
                                this.store.dispatch({
                                    type: projectActions.GET_IS_PROJECT_EXISTS,
                                    payload: { projectId: id }
                                })
                            }
                            else {
                                this.state.go('app.authorized.environments', { id: id, name: name });
                            }
                        });
                    });

                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: this.$translate('ERROR_OCCURRED'),
                        text: (response.data.validationErrors[0]['ErrorMsg']) ?
                            response.data.validationErrors[0]['ErrorMsg'] : ''//JSON.stringify(response.data.validationErrors[0]['ErrorMsg']) : ''
                    });
                }
            }
        }).then(() => {
            this.store.dispatch({ type: licenseActions.GET_LICENSE_WARNINGS });
        }).catch((err) => console.log('finish error', err));
    }


    saveDraft() {
        this.projectData.userInitiatedChange = true;
        this.store.dispatch({ type: projectActions.SAVE_DRAFT, payload: { project: this.projectData } }).then((resp) => {
            if (resp.data.validationErrors == null) {
                if (resp.data.projectDraft.id != 0 && (this.projectData == null || this.projectData.id == 0)) {
                    this.projectsLocalHistoryService.AddProjectHistory({ id: parseInt(resp.data.projectDraft.id), name: resp.data.projectDraft.name, isDraft: true }, this.state.$current.locals.globals.userDetails.data.id);
                    this.state.go('app.authorized.environments', { id: resp.data.projectDraft.id });
                    this.store.dispatch({
                        type: projectActions.GET_EDIT_PROJECT,
                        payload: { projectId: resp.data.projectDraft.id },
                        callback: (response) => {
                            this.store.dispatch({
                                type: projectActions.SET_EDIT_MODE,
                                payload: {
                                    editMode: true,
                                    isNew: (!response.data.parentId) ? true : false,
                                    isNewDraft: response.data.isNew
                                }
                            });
                        }
                    });
                    this.projectData = resp.data.projectDraft
                }
                this.dialogManagerService.showSuccessDialog({ title: this.$translate('SUCCESS_PROJECT_DRAFT_SAVE'), text: '' });
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: 'Error Occured',
                    text: (resp.data.validationErrors[0]['ErrorMsg']) ?
                        resp.data.validationErrors[0]['ErrorMsg'] : '' //JSON.stringify(resp.data.validationErrors[0]['ErrorMsg']) : ''
                });
            }
        });
    }

    insertToJson(fieldName, value, fieldName2 = null, fieldName3 = null) {
        // let pdata = this.projectData;
        // for (let index = 0; index < fieldName.length; index++) {
        //     const element = fieldName[index];
        //     if(element){
        //         if(index==0){
        //             this.projectData[element] = value;
        //         }
        //         else if(index==1){
        //             if(fieldName[index+1]){
        //                 if(this.projectData[fieldName[index-1]][element] == undefined){
        //                     this.projectData[fieldName[index-1]][element] = {};
        //                 }
        //             }
        //             else{
        //                 this.projectData[fieldName[index-1]][element] = value;
        //             }
        //         }
        //         else if(index==2){
        //             if(fieldName[index+1]){
        //                 if(this.projectData[fieldName[index-2]][fieldName[index-1]][element] == undefined){
        //                     this.projectData[fieldName[index-2]][fieldName[index-1]][element] = {};
        //                 }
        //             }
        //             else{
        //                 this.projectData[fieldName[index-2]][fieldName[index-1]][element] = value;
        //             }
        //         }
        //     }
        // }
        if (fieldName2 != null) {
            if (fieldName3 != null) {
                if (this.projectData[fieldName][fieldName2] == undefined) {
                    this.projectData[fieldName][fieldName2] = {};
                }
                this.projectData[fieldName][fieldName2][fieldName3] = value
            }
            else {

                this.projectData[fieldName][fieldName2] = value
            }
        }
        else {
            this.projectData[fieldName] = value
        }
    }

    validate() {
        let invalidCharsRegex = /([!@#$%^*(){}[\];\\?/|<>",.+\-:=])+/ig;
        let newProjectForm = this.form.newProjectForm;
        if (newProjectForm && newProjectForm.name
            && newProjectForm.name.$name == "name"
            && newProjectForm.name.$modelValue.length <= 2) {
            this.dialogManagerService.showErrorDialog({
                title: this.$translate('ERROR_OCCURRED'),
                text: `'${newProjectForm.name.$modelValue}' ${this.$translate('ERROR_SHORT_PROJECT_NAME')}`
            });
            return false;
        }
        if (newProjectForm && newProjectForm.name && newProjectForm.name.$name == "name") {
            let match = newProjectForm.name.$modelValue.match(invalidCharsRegex);
            if (match != null) {
                this.dialogManagerService.showErrorDialog({
                    title: this.$translate('ERROR_OCCURRED'),
                    text: this.$translate('ERROR_PROJECT_NAME_WITH_INVALID_CHARS') + match.join(',')
                });
                return false;
            }
        }

        // if (newProjectForm && newProjectForm.name &&
        //     newProjectForm.name.$name == "name") { }
        this.isValid = true;

        if (this.projectData.environmentTypes != null && this.stepId() == 3) {
            this.projectData.environmentTypes.forEach((envType) => {
                if (envType.environments != null) {
                    envType.environments.forEach((env) => {
                        let match = env.name.match(invalidCharsRegex);
                        if (match != null) {
                            const message_format = this.$translate('ERROR_ENVIROMNET_NAME');
                            const msg = _str.sprintf(message_format, env.name)
                            this.dialogManagerService.showErrorDialog({
                                title: this.$translate('ERROR_OCCURRED'),
                                text: `${msg} ${match.join(',')}`
                            });
                            if (this.isValid)
                                this.isValid = false;
                        } else {
                            if (env.name.length <= 1) {
                                const message_format = this.$translate('ERROR_SHORT_ENVIROMNET_NAME');
                                const msg = _str.sprintf(message_format, env.name)
                                this.dialogManagerService.showErrorDialog({ title: this.$translate('ERROR_OCCURRED'), text: `${msg}` });
                                if (this.isValid)
                                    this.isValid = false;
                            }
                        }
                    });
                }
            })
        }

        if (newProjectForm && newProjectForm.$invalid) {
            return false;
        }
        return true;
    }

    disableNext() {
        switch (this.stepId()) {
            case 1:
                var name = (this.projectData && this.projectData.name) ? false : true;
                var dbType = (this.projectData && this.projectData.databaseType) ? false : true;
                var projectGroup = (this.projectData && this.projectData.projectGroupId) ? false : true;
                const cmsChecked = this.projectData && this.projectData.options && this.projectData.options.CMS === true;
                const cmsProject = (cmsChecked && !(this.projectData.connectedCmsProject && this.projectData.connectedCmsProject.cmsId)) ? true : false;
                return (name || dbType || projectGroup || cmsProject)
            case 2:
                if (!this.projectData.dataFlowType || this.projectData.dataFlowType == 0) {
                    return true;
                }
                return false;
            case 3:
                return false;
        }
    }

    next() {
        if (!this.validate()) {
            return;
        }
        switch (this.state.params.step + 1) {
            case 2:
                this.m_goToEnvTypes()
                break;
            case 3:
                this.m_goToAssignSchemas()
                break;
        }
    }

    back() {
        switch (this.state.params.step - 1) {
            case 1:
                this.m_goToSettings();
                break;
            case 2:
                this.m_goToEnvTypes();
                break;
        }
    }

    resetLocalStorage() {
        this.projectData = null;
        this.resetMainScripts = true;
        this.store.getState().project.data = null;
        this.store.getState().project.environmentTypes = null;
        if (this.state.params.id != 0) {
            this.store.dispatch({ type: projectActions.GET_EDIT_PROJECT, payload: { projectId: parseInt(this.state.params.id) } }).then((resp) => {
                this.m_goToSettings()
                return resp;
            });
        } else {
            this.store.dispatch({ type: projectActions.GET_NEW_PROJECT, payload: { projectType: 1 } }).then((resp) => {
                this.m_goToSettings()
                return resp;
            });
        }
    }

    m_goToSettings() {
        this.state.go('app.authorized.projectWizard.settings', {
            id: this.state.params.id,
            step: 1,
            remember: 'edit'
        });
    }

    m_goToEnvTypes() {
        this.state.go('app.authorized.projectWizard.envTypes'
            , {
                id: this.state.params.id,
                step: 2,
                continued: true,
                dbType: (this.projectData.databaseType) ? this.projectData.databaseType.key : this.state.params.dbType
            }
        );
    }

    m_goToAssignSchemas() {
        //const assignSchemasShepherdStepId = "clickOnEnv";
        this.projectData.userInitiatedChange = true;
        //oleg default for all databases beside mssql (that need to choose) - usedowngradescripts = true;

        //Don;t change the server default
        //if (this.projectData.dbTypeId !== 1)
        //    this.projectData.options.UseDowngradeScripts = true;  

        this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });
        this.state.go('app.authorized.projectWizard.assignSchemas', {
            //should be id or dbType - didnt change for now still id? 
            id: this.state.params.id,
            continued: true,
            step: 3,
            //dbType: (this.projectData.databaseType) ? this.projectData.databaseType.key : this.state.params.dbType 
            dbType: (this.projectData.dbType) ? this.projectData.dbTypeId : this.state.params.dbType
        });
        //this.shepherdGuidenceService.goToStep(assignSchemasShepherdStepId);
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/projectWizard-ang7.ts